 <template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. قسم التحكم والبحث (يختفي عند الطباعة) -->
    <div class="card mb-4 no-print">
      <div class="card-header bg-success text-white">
        <h5 class="mb-0">إحصاء عددي مجمع (كل المجموعات)</h5>
      </div>

      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select
              @change="getSubjectswithtearm(form.term)"
              v-model="form.term"
              class="form-control"
            >
              <option value="">اختر الفصل الدراسي</option>
              <option v-for="t in terms" :key="t.id" :value="t">
                {{ t.name }}
              </option>
            </select>
          </div>

          <div class="col-md-6">
            <label class="form-label fw-bold">المادة</label>
            <select v-model="form.subject" class="form-control">
              <option value="">اختر المادة</option>
              <option v-for="s in subjects" :key="s.id" :value="s">
                {{ s.name }}
              </option>
            </select>
          </div>
          <!-- تم حذف اختيار المجموعة لأننا سنجلب الكل -->
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button @click="getAllGroupsStatistics" class="btn btn-warning text-dark mx-2">
            <i class="fas fa-search"></i> عرض الإحصاء للكل
          </button>
          
          <button @click="print" class="btn btn-info text-white mx-2" :disabled="AllGroups.length === 0">
            <i class="fas fa-print"></i> طباعة الكل
          </button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة التقرير -->
    <div v-if="AllGroups.length > 0" class="print-area" id="printMe">
      
      <!-- حلقة تكرار: لكل مجموعة صفحة مستقلة -->
      <div 
        v-for="(groupData, index) in AllGroups" 
        :key="index" 
        class="single-page-report"
        style="page-break-after: always;"
      >
        
        <!-- ترويسة التقرير -->
        <div class="report-header mb-4 text-center border-bottom pb-3">
          <div class="row align-items-center">
            <div class="col-4 text-start">
               <p class="mb-1"><strong>الكنترول المركزي</strong></p>
               <p class="mb-0"><strong>الغرفة السرية</strong></p>
            </div>
            <div class="col-4 text-center">
              <h3 class="mb-2">إحصاء عددي للمجموعة</h3>
              <span class="badge bg-secondary fs-6">{{ form.term ? form.term.name : '' }}</span>
            </div>
            <div class="col-4 text-center">
               <p class="mb-1"><strong>المادة:</strong> {{ form.subject ? form.subject.name : '---' }}</p>
               <p class="mb-0 fs-4 border border-dark p-1"><strong>مجموعة: {{ groupData.group_no }}</strong></p>
            </div>
          </div>
        </div>

        <!-- جدول الإحصاء -->
        <div class="table-responsive">
          <table class="table table-bordered table-hover align-middle text-center table-report">
            <thead class="table-light">
              <tr>
                <th style="width: 20%">البيان / نوع الأوراق</th>
                <th style="width: 60%">الأرقام السرية</th>
                <th style="width: 20%">العدد</th>
              </tr>
            </thead>
            <tbody>
              <!-- الغياب -->
              <tr>
                <td class="fw-bold">الغياب</td>
                <td>
                  <div class="d-flex flex-wrap justify-content-center gap-1">
                    <span v-for="(abs, i) in groupData.student_abs" :key="'abs'+i" class="badge bg-danger fs-5">
                      {{ abs.SecretKey }}
                    </span>
                  </div>
                </td>
                <td class="fw-bold fs-5">{{ groupData.student_abs.length }}</td>
              </tr>

              <!-- لغات -->
              <tr>
                <td class="fw-bold">لغات</td>
                <td>
                  <div class="d-flex flex-wrap justify-content-center gap-1 fs-5">
                    <span v-for="(lang, i) in groupData.student_lang" :key="'lang'+i" class="badge bg-primary fs-5">
                      {{ lang.SecretKey }}
                    </span>
                  </div>
                </td>
                <td class="fw-bold fs-5">{{ groupData.student_lang.length }}</td>
              </tr>

              <!-- دمج -->
              <tr>
                <td class="fw-bold">طلاب دمج</td>
                <td>
                  <div class="d-flex flex-wrap justify-content-center gap-1 fs-5">
                    <span v-for="(damge, i) in groupData.student_damge" :key="'damge'+i" class="badge bg-warning text-dark fs-5">
                      {{ damge.SecretKey }}
                    </span>
                  </div>
                </td>
                <td class="fw-bold fs-5">{{ groupData.student_damge.length }}</td>
              </tr>

              <!-- لجنة خاصة -->
              <tr>
                <td class="fw-bold">لجنة خاصة</td>
                <td>
                  <div class="d-flex flex-wrap justify-content-center gap-1 fs-5">
                    <span v-for="(khas, i) in groupData.student_khas" :key="'khas'+i" class="badge bg-info text-dark fs-5">
                      {{ khas.SecretKey }}
                    </span>
                  </div>
                </td>
                <td class="fw-bold fs-5">{{ groupData.student_khas.length }}</td>
              </tr>

              <!-- الدين المسيحي -->
              <tr>
                <td class="fw-bold">الدين المسيحي</td>
                <td>---</td>
                <td class="fw-bold"></td>
              </tr>

              <!-- الإجماليات -->
              <!-- نحسب المجموع الخاص بهذه المجموعة فقط -->
              <tr class="table-secondary">
                <td colspan="2" class="text-center fw-bold ps-4">إجمالي (خارج الورق / المستبعد)</td>
                <td class="fw-bold text-danger fs-5">{{ calculateTotal(groupData) }}</td>
              </tr>

              <tr class="table-success">
                <td colspan="2" class="text-center fw-bold ps-4">إجمالي الورق (المتبقي للتصحيح)</td>
                <td class="fw-bold text-success fs-5">{{ 200 - calculateTotal(groupData) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="report-footer mt-4 text-start text-muted fs-6">
          * تم توليد التقرير بواسطة نظام إدارة الكنترول
        </div>

        <!-- فاصل صفحات إجباري بعد كل مجموعة -->
        <div class="page-break"></div>

      </div> 
    </div>

  </div>
</template>

<script>
import api from "../../api/axios";

export default {
  data() {
    return {
      subjects: [],
      terms: [],
      AllGroups: [], // مصفوفة لتخزين بيانات كل المجموعات

      form: {
        subject: "",
        term: "",
      },
    };
  },

  mounted() {
    api.get("/getterms").then((res) => { this.terms = res.data; });
    // لاحظ: لا نحتاج لجلب المجموعات للقائمة المنسدلة لأننا سنجلب الكل
  },

  methods: {
    getSubjectswithtearm(id) {
      api.get("/getSubject/" + id.id).then((res) => {
        this.subjects = res.data;
      });
    },

    getAllGroupsStatistics() {
      if(!this.form.subject || !this.form.term) {
          alert("الرجاء اختيار الترم والمادة");
          return;
      }

      api
        .post("/countStatisticsAll", this.form) // دالة جديدة في الباك اند
        .then((res) => {
          this.AllGroups = res.data;
        })
        .catch((e) => {
            console.error(e);
        });
    },
    
    // دالة حساب الإجمالي لمجموعة واحدة
    calculateTotal(groupData) {
        return (groupData.student_abs.length || 0) +
               (groupData.student_lang.length || 0) +
               (groupData.student_damge.length || 0) +
               (groupData.student_khas.length || 0);
    },

    print() {
      this.$htmlToPaper("printMe");
    },
  },
};
</script>

<style scoped>
/* نفس التنسيقات السابقة */
.container { direction: rtl; text-align: right; }
.badge { font-size: 1.1em; padding: 5px 10px; }

/* أهم جزء: تنسيق الطباعة */
@media print {
  .no-print { display: none !important; }
  
  /* كل ديف يحمل هذا الكلاس يبدأ في صفحة جديدة */
  .page-break { 
    page-break-after: always; 
    display: block; 
    height: 1px;
  }
  
  /* ضمان عدم قص الجدول في المنتصف */
  .single-page-report {
      page-break-inside: avoid;
      min-height: 95vh; /* لضمان أخذ الصفحة كاملة */
  }
  
  .table-bordered th, .table-bordered td {
      border: 1px solid #000 !important;
  }
}
</style>